import React from 'react';
import AbstractIcon from 'icons/AbstractIcon'


const svg = (
<svg viewBox="0,0,64,64">
  <path
    d="M33.402 38.3v18.634c.796-.135 1.562-.4 2.262-.814l15.47-8.865a7.22 7.22 0 0 0 3.618-6.332v-17.64a5.3 5.3 0 0 0-.362-2.08l-16.735 9.68c-3.528 2.442-4.252 4.704-4.252 7.417z"
    fill="#ffc100" />
  <path
    d="M60.54 17.595l-6.15 3.527a7.75 7.75 0 0 1 .362 2.08v17.73a7.41 7.41 0 0 1-3.618 6.332l-15.47 8.866a9.63 9.63 0 0 1-2.262.814V64c1.083-.17 2.126-.537 3.076-1.085l20.082-11.5a9.08 9.08 0 0 0 4.523-7.87V20.58c-.004-1.02-.188-2.03-.543-2.985z"
    fill="#f6eb61" />
  <path
    d="M31.955 32.43c1.073-1.652 2.532-3.02 4.25-3.98l16.917-9.768c-.55-.718-1.224-1.33-2-1.8L35.665 8.006a7.54 7.54 0 0 0-7.328 0L12.96 16.87a7.89 7.89 0 0 0-2.08 1.809l16.825 9.77a13.01 13.01 0 0 1 4.252 3.98z"
    fill="#439879" />
  <path
    d="M12.96 16.96l15.378-8.865a7.54 7.54 0 0 1 7.328 0l15.468 8.865a6.36 6.36 0 0 1 1.99 1.809l6.15-3.528a7.46 7.46 0 0 0-2.713-2.352L36.478 1.22a8.99 8.99 0 0 0-9.046 0L7.53 12.8a8.79 8.79 0 0 0-2.713 2.442l6.15 3.528a5.51 5.51 0 0 1 1.99-1.809z"
    fill="#28cdfb" />
  <path
    d="M28.337 56.13L12.96 47.265a7.22 7.22 0 0 1-3.618-6.332v-17.73a7.2 7.2 0 0 1 .27-2l-6.15-3.526a8.21 8.21 0 0 0-.543 2.895V43.64c-.027 3.225 1.707 6.207 4.523 7.78l20 11.5c.95.548 1.992.916 3.076 1.085V56.95a5.35 5.35 0 0 1-2.17-.814z"
    fill="#fdd757" />
  <path
    d="M26.256 30.8L9.6 21.213c-.18.648-.27 1.318-.27 2v17.73a7.22 7.22 0 0 0 3.619 6.332l15.378 8.865a9.63 9.63 0 0 0 2.262.814V38.3c-.1-2.713-.815-4.976-4.342-7.508z"
    fill="#ec8b00" />
  </svg>
)

export default (props) => {
  return (<AbstractIcon
    {...props}
    svg={svg}
    title="Balena Cloud"
    href="https://www.balena.io/"
  />)
}